import React from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Box, TextField } from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import "dayjs/locale/en";
import "dayjs/locale/ar";
import { useTranslation } from "react-i18next";

const DatepickerFilter = React.memo(
  ({ label, value, onChange, isDark, minDate, maxDate, handleBlur, touched, error, name, column, row, inputProps }) => {
    const { i18n } = useTranslation();
    const dateValue = value ? dayjs(value) : null;
    const locale = (i18n.language || "fr").startsWith("ar")
      ? "ar"
      : (i18n.language || "fr").startsWith("en")
        ? "en"
        : "fr";

    return (
      <Box sx={{ gridColumn: column, gridRow: row, width: name ? "100%" : "auto" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
          <DatePicker
            label={label}
            value={dateValue}
            onChange={onChange}
            format="DD/MM/YYYY"
            minDate={minDate ?? undefined}
            maxDate={maxDate ?? undefined}
            renderInput={(params) => (
              name && name !== "" ? (
                <TextField
                  {...params}
                  fullWidth
                  variant="filled"
                  onBlur={handleBlur}
                  name={name}
                  error={!!touched && !!error}
                  helperText={touched && error}
                  inputProps={{
                    ...params.inputProps,
                    ...inputProps,
                  }}
                />) : (
                <TextField
                  {...params}
                  size="small"
                  sx={{
                    minWidth: 140,
                    width: { xs: "100%", sm: 160 },
                  }}
                />
              )
            )}
          />
        </LocalizationProvider>
      </Box>
    );
  }
);

export default DatepickerFilter;
